
import React from 'react'
import useReportes from '../../hooks/adminexamen/useReportes';
import { Row, Divider, List, Typography, BackTop } from "antd";
import ReporteGeneral from "../../components/ReporteGeneral";
import ReporteEstadoExamen from "../../components/ReporteEstadoExamen";
import ReporteResultadoExamenCarrera from "../../components/ReporteResultadoExamenCarrera";
import ExpedienteReportesEnviadosPorCorreo from "../../components/ExpendienteReportesEnviadosPorCorreo";
// eslint-disable-next-line
import { indice_reportes } from "../../data/datos";
import { LinkOutlined } from "@ant-design/icons";
import ReporteAspiranteExamenPendiente from "../../components/ReporteAspiranteExamenPendiente";
import ReporteAgrupandoMatematicas from "../../components/ReporteAgrupandoMatematicas";
import { Toaster } from "react-hot-toast";
import ReporteAspirantesExamen from "../../components/ReporteAspirantesExamen";
import PromediosResultados from "../../components/PromediosResultados";
import PromediosResultadosIngles from "../../components/PromediosResultadosIngles";
import ReporteGeneralMaestria from '../../components/ReporteGeneralMaestria';


const { Link } = Typography;

export const Reportes = () => {

    const { cardMateria, aspirantesPorCarrera, SelectCiclo } = useReportes();


    return (
        <>

            <BackTop />
            <Toaster/>

            {/* hola :D este es un índice */}
            <List
                size="small"
                header={<h2 className='ta-center'>Índice</h2>}
                bordered
                // eslint-disable-next-line
                dataSource={ indice_reportes }
                renderItem={ (item) => (
                    <List.Item>
                        <Link href={ '#'+item.id }>
                            { item.titulo } <LinkOutlined />
                        </Link>
                    </List.Item>
                )}
            />

            {/* estas son las respuestas correctas por materia */}
            {/* estas son las respuestas correctas por materia */}
            <Divider id="respuestas_correctas_por_materia" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#respuestas_correctas_por_materia'>Respuestas correctas por materia</a>
            </Divider>
            <Row gutter={16}>
                { cardMateria() }
            </Row>
            <br/>

            {/* cantidad de aspirantes por materia */}
            <Divider id="cantidad_de_aspirantes_por_carrera" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#cantidad_de_aspirantes_por_carrera'>Cantidad de aspirantes por carrera</a>
            </Divider>
            <SelectCiclo/>
            <Row gutter={16}>
                { aspirantesPorCarrera()  }
            </Row>
            <br/>



            {/* cantidad de aspirantes por materia */}
            <Divider id="aspirantes_participantes_en_aplicacion" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#aspirantes_participantes_en_aplicacion'>Aspirantes que participaron por aplicación</a>
            </Divider>
            <Row gutter={16}>
                <ReporteAspirantesExamen/>
            </Row>
            <br/>


            {/* ENVÍO MASIVO DE RESULTADOS A LOS ASPIRANTES */}

            {/*
            <Divider id="aspirantes" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>Aspirantes</Divider>
            <Button type="primary" disabled onClick={() => { enviarReportesIndividualesPorCorreo() }}>Enviar correo de resultados a cada aspirante</Button>
            <br/>
            <br/>
            */}


            {/* ACTUALIZACIÓN MASIVA DEL ESTADO EXAMEN DE TODOS LOS ASPIRANTES A 1, CON MÍNIMO UNA RESPUESTA EN CADA MATERIA*/}
            {/*
            <Button type="primary" disabled onClick={() => { actualizarEstadoExamenAspirantes() }}>Actualizar estado examen de aspirantes</Button>
            */}



            {/* //! pendiente de agregar select */}
            <Divider id="expedientes_reportes_individuales_enviados_por_correo_aspirantes" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#expedientes_reportes_individuales_enviados_por_correo_aspirantes'>
                    Expedientes de reportes individuales enviados por correo a aspirantes
                </a>
            </Divider>
            <ExpedienteReportesEnviadosPorCorreo/>



            {/* //! pendiente de agregar select */}
            <Divider id="aspirantes_con_exámenes_pendientes" orientation="left" style={{ marginBottom: 30, marginTop: 45 }}>
                <a href='#aspirantes_con_exámenes_pendientes'>Aspirantes con exámenes pendientes</a>
            </Divider>
            <ReporteAspiranteExamenPendiente/>



            {/* //! pendiente de agregar select */}
            <Divider id="estado_de_aspirantes_en_cada_examen" orientation="left" style={{ marginBottom: 30, marginTop: 45 }}>
                <a href='#estado_de_aspirantes_en_cada_examen'>Estado de aspirantes en cada examen</a>
            </Divider>
            <ReporteEstadoExamen/>


            {/* <Divider orientation="left">Estado general por materia</Divider>
            <Row>
                { [1, 2, 3, 4].map(e => (
                    <Col key={ e } xs={ 24 } lg={ 12 } style={{ marginBottom: 50, marginTop: 50 }}>
                        <GraficaPastel pk_materia={ e }/>
                    </Col>
                ))}
            </Row> */}



            {/* // * ya tiene select :D */}
            <Divider id="resultados_por_carrera" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#resultados_por_carrera'>Resultados por carrera</a>
            </Divider>
            <ReporteResultadoExamenCarrera/>


            {/* // ! no necesita select  */}
            <Divider id="resultados_agrupando_matemáticas" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#resultados_agrupando_matemáticas'>Resultados agrupando matemáticas</a>
            </Divider>
            <ReporteAgrupandoMatematicas/>


            {/* // * ya tiene select :D */}
            <Divider id="promedios_resultados_aspirantes" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#promedios_resultados_aspirantes'>Promedios de resultados de aspirantes</a>
            </Divider>
            <PromediosResultados/>



            {/* // * ya tiene select :D */}
            <Divider id="promedios_resultados_aspirantes_ingles" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#promedios_resultados_aspirantes_ingles'>Promedios de resultados de aspirantes en Inglés</a>
            </Divider>
            <PromediosResultadosIngles/>


            {/* // TODO: FALTA DE AGREGAR SELECT */}
            <Divider id="respuestas_correctas_por_aspirante" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#respuestas_correctas_por_aspirante'>Respuestas correctas por aspirante (Licenciatura)</a>
            </Divider>
            <ReporteGeneral/>


            {/* // TODO?: FALTA DE AGREGAR SELECT */}
            <Divider id="respuestas_correctas_por_aspirante_maestria" orientation="left" style={{ marginBottom: 30, marginTop: 40 }}>
                <a href='#respuestas_correctas_por_aspirante_maestria'>Respuestas correctas por aspirante (Maestría)</a>
            </Divider>
            <ReporteGeneralMaestria/>

        </>
    )

}
